// extracted by mini-css-extract-plugin
export var askAiIcon = "_q9-9";
export var container = "_q9-0";
export var groupSeparator = "_q9-a";
export var highlight = "_q9-4";
export var resultIcon = "_q9-5";
export var resultItem = "_q9-7";
export var resultSubtitle = "_q9-3";
export var resultTitle = "_q9-2";
export var resultsList = "_q9-1";
export var searchGroup = "_q9-6";
export var selected = "_q9-8";